var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutocarro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0000000000000002,0,0,1.0000000000000002,-5.684341886080802e-14,1.1368683772161603e-13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.239 250.669 429.974 233.7l-19.645-44.9-14.658 6.414L411.768 232H368v-80h8.77l11.9 27.207 14.658-6.414-19.611-44.834A40.019 40.019 0 0 0 347.07 104H48a32.036 32.036 0 0 0-32 32v16h16v-16a16.019 16.019 0 0 1 16-16h299.07a24.013 24.013 0 0 1 21.99 14.375l.711 1.625H320a16.019 16.019 0 0 0-16 16v80a16.019 16.019 0 0 0 16 16h102.55l47.071 17.651A16.071 16.071 0 0 1 480 280.63V288h-24a16.019 16.019 0 0 0-16 16v16h-18.083a55.924 55.924 0 0 0-91.834 0H165.917a55.924 55.924 0 0 0-91.834 0H64v-24a8 8 0 0 0-8-8H32V168H16v192a16.019 16.019 0 0 0 16 16h37.414a55.99 55.99 0 0 0 104.245-40h148.682a55.689 55.689 0 0 0-1.76 24H192v16h133.414a55.99 55.99 0 0 0 104.245-40H480v24h-32v16h32a16.019 16.019 0 0 0 16-16v-79.37a32.146 32.146 0 0 0-20.761-29.961zM320 152h32v80h-32zM48 304v16H32v-16zm-16 56v-24h34.341a55.689 55.689 0 0 0-1.76 24zm88 32a40 40 0 1 1 40-40 40.045 40.045 0 0 1-40 40zm256 0a40 40 0 1 1 40-40 40.045 40.045 0 0 1-40 40zm80-72v-16h24v16z",
    fill: "#008944",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 136h240v16H48zM48 232h240v16H48zM376 328a24 24 0 1 0 24 24 24.027 24.027 0 0 0-24-24zm0 32a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8zM120 328a24 24 0 1 0 24 24 24.027 24.027 0 0 0-24-24zm0 32a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8zM312 264h32v16h-32zM256 264h32v16h-32z",
    fill: "#008944",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutocarro);
export default __webpack_public_path__ + "static/media/autocarro.7a4966274deb2ab9a97215c01f42d340.svg";
export { ForwardRef as ReactComponent };